// src/utils/tileImageUtils.ts

interface TileWithParentImages {
  tile_display_media_single_link?: string | null;
  // parent_category_id -> image url, set per collection in the hub ("Tile Images by Parent")
  custom_tile_data_urls?: Record<string, string> | null;
}

type ParentCategoryId = string | null | undefined;

/**
 * Image for a collection tile shown under a specific parent page (e.g. an application).
 * Uses the image set for that parent when there is one, otherwise the tile's main image.
 * Pass several ids in priority order when a tile could be keyed by more than one parent;
 * the first one with an image wins.
 */
export const getParentTileImage = (
  tile: TileWithParentImages,
  parentCategoryIds?: ParentCategoryId | ParentCategoryId[]
): string | null => {
  const candidates = Array.isArray(parentCategoryIds) ? parentCategoryIds : [parentCategoryIds];
  for (const parentCategoryId of candidates) {
    const parentImage = parentCategoryId ? tile.custom_tile_data_urls?.[parentCategoryId] : undefined;
    if (parentImage) return parentImage;
  }
  return tile.tile_display_media_single_link || null;
};
